import axiosFactory from "./axios.factory";

class OqsSettingsService {
  async getSettings() {
    const result = await axiosFactory().get("/oqs_settings");
    return result.data.data;
  }

  async saveSettings(updates) {
    const result = await axiosFactory().put("/oqs_settings", updates);
    return result.data.data;
  }
}

export default new OqsSettingsService();
